import useMessage from '../Hooks/useMessage'

import axios from 'axios'
export const mainUrl = process.env.REACT_APP_URL // "http://localhost:3000/";
export const baseURL = process.env.REACT_APP_API_URL // Коллеги нужно использовать это! Смотрите пример .env.local.example

export const apiURL = '/api/v1/'
// export const baseURL = "https://api.bolashak.crocos.kz/api/v1/";
// export const baseURL = "https://api-konkurs.bolashak.gov.kz"; // Это уже старый вариант!
// export const baseURL = "https://api-konkurs.bolashak.gov.kz"; // "http://localhost:8000"; Если env не настроен

const axiosInstance = axios.create({
	baseURL: `${baseURL}${apiURL}`,
	headers: {
		'Content-type': 'application/json',
		'Access-Control-Allow-Origin': '*',
		'X-locale': localStorage.getItem('i18nextLng'),
	},
})

// axiosInstance.interceptors.response.use(function (response) {
//   // Any status code that lie within the range of 2xx cause this function to trigger
//   // Do something with response data

//   return response;
// }, function (error) {
//   // Any status codes that falls outside the range of 2xx cause this function to trigger
//   // Do something with response error
//   const {  addMessage } = useMessage();

//   if (error?.response?.data?.error_messages) {
//     Object.values(error?.response?.data?.error_messages).map((message) =>
//       addMessage(message[0], "error")
//     );
//   } else {
//     const resMessage =
//       error?.response?.data?.error_message ||
//       error.message ||
//       error.toString();
//     addMessage(resMessage, "status");
//   }
//   return Promise.reject(error);
// });

export default axiosInstance
